import { httpCreate } from './http';

const http = httpCreate('/srv/sts');

export const sts = {
	getToken(id) {
		return http.get(`/${id}`);
	},
	getDocumentsToken(id) {
		return http.get(`${id}/docs`);
	}
}